import { computed, Ref, ref } from 'vue'
import { useStore } from 'vuex'
import { Year } from '@/store/type/year.type'
import { ReferencePointItemsType } from '@/store/type/referencePoint.type'
import { BoundaryConditionsReferencePointType } from '@/store/type/boundaryConditions.type'

export const boundaryConditionTableMixin = (
  storeNamespace: string,
  items: Ref<Array<BoundaryConditionsReferencePointType>>,
  selectedItem: Ref<BoundaryConditionsReferencePointType>,
  getDirtyClass: (item: BoundaryConditionsReferencePointType, field: string) => string,
  deleteItems: (item: BoundaryConditionsReferencePointType) => Promise<void>,
  deleteFromState: (item: BoundaryConditionsReferencePointType) => Promise<void>,
  emit: (event: 'changePage') => void
) => {
  const DEFAULT_ITEM_PER_PAGE = 10
  const activeYears = ref<Year[]>([])
  const itemPerPage = ref<number>(DEFAULT_ITEM_PER_PAGE)
  const page = ref(1)

  const store = useStore()

  const referencePoints = computed<ReferencePointItemsType>(() => store.state.referencePoint.items)
  const availableReferencePoints = computed<number[]>(
    () => store.state[storeNamespace].availableReferencePoints
  )

  const referencePointsOptions = computed(() => {
    const points = referencePoints.value ? Array.from(referencePoints.value.features) : []

    points.forEach((ref) => {
      const index = availableReferencePoints.value.findIndex((usedRef) => ref['id'] === usedRef)
      ref['disabled'] = index < 0
    })

    return points
  })
  const referencePointsShow = computed(() => {
    const startIndex = itemPerPage.value * (page.value - 1)
    const endIndex = itemPerPage.value * page.value
    return items.value ? items.value.slice(startIndex, endIndex) : []
  })
  const activeYearsId = computed<number[]>(() => {
    return activeYears.value.map((year) => year.id)
  })

  const displayFilter = (bool: boolean) => {
    if (bool) {
      return 'display: table-cell;'
    } else {
      return 'display: none;'
    }
  }
  const filterYearId = (year: number): string => {
    const bool = activeYearsId.value.includes(year)
    return displayFilter(bool)
  }
  const borderBottom = (referencePoint: BoundaryConditionsReferencePointType) => {
    return referencePoint.id <= 0
      ? 'border-bottom-red'
      : getDirtyClass(referencePoint, referencePoint.id.toString())
  }
  const updateOptions = async (options: {
    itemsPerPage: number
    page: number
    [key: string]: any
  }) => {
    const currentPage = items.value.length / options.itemsPerPage
    if (options.page > currentPage) {
      emit('changePage')
    }
    page.value = options.page
  }
  const deleteReferencePoint = async () => {
    try {
      await deleteItems(selectedItem.value)
      await deleteFromState(selectedItem.value)
    } catch (e) {
      console.log(e)
    }
  }
  return {
    itemPerPage,
    page,
    referencePoints,
    referencePointsOptions,
    referencePointsShow,
    activeYears,
    activeYearsId,
    filterYearId,
    borderBottom,
    updateOptions,
    deleteReferencePoint,
    displayFilter
  }
}
